import type { KeyHandler } from 'hotkeys-js';
import hotkeys from 'hotkeys-js';
import { injectable } from 'inversify';

@injectable()
export class HotKeysService {
  public constructor() {
    this._preventDefaultUndo();
  }

  private _preventDefaultUndo(): void {
    window.addEventListener('keydown', (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'z') {
        event.preventDefault();
      }
    });
  }

  public registerHotKey(key: string, callback: KeyHandler): void {
    hotkeys(key, callback);
  }
}
